import { HttpQuery } from "@/interfaces/httpQuery";
import { User } from "@/interfaces/user";
import { policyList } from "@/internal";
import { EventBus, store } from "@/internal";
import { API_URIS } from "@/utils/constants";
import { TableAction, TableSuccessModalResponse } from "helix-vue-components";
import Http2Service from "./http2.service";

export class UserService extends Http2Service {
  constructor() {
    super();
  }

  /**
   * Retrieves the list of users.
   * @param query?: HttpQuery
   * @returns Promise<User[]>
   */
  public async getUsers(query?: HttpQuery): Promise<User[]> {
    const response = await this.get(API_URIS.USER, query);
    return response.data.data;
  }

  /**
   * Returns the configuration por actionson top of the table.
   */
  public getGeneralActions() {
    return [
      {
        icon: "fal fa-plus",
        class: "buttonClass_5",
        id: "btn_create_user",
        visibleCondition: () =>
          store.getters["authModule/hasPermission"](policyList.createUsers),
        disabled: () => {
          const availability =
            store.getters["AccountManagementModule/availability"];
          return !!availability && !availability.users.available;
        },
        tooltip: {
          text: "user_message",
          displayCondition: () => {
            const availability =
              store.getters["AccountManagementModule/availability"];
            return !!availability && !availability.users.available;
          }
        },
        action: (...arg: any[]) => {
          EventBus.$emit("route", {
            name: "user-management-add",
            currentModel: arg[0]
          });
        },
        componentName: "TableButtonComponent"
      },
      {
        icon: "fal fa-search",
        class: "buttonClass_5",
        id: "btn_search_user",
        componentName: "TableButtonComponent",
        otherComponent: {
          name: "TableSearchComponent"
        }
      }
    ];
  }

  /**
   * Returns actions configuration for each row.
   * @returns TableAction[]
   */
  public getRowActions(execute: Function, modifyUser: boolean): TableAction[] {
    return [
      {
        icon: modifyUser ? "fal fa-pen" : "fal fa-eye",
        class: "table__actions",
        id: "btn_edit_user",
        action: (...arg: any[]) => {
          const current: User = arg[0];
          current.profile = current.profile!;
          delete current.profile;
          const payload = {
            name: modifyUser ? "user-management-edit" : "user-management-view",
            params: {
              id: current.id,
              currentModel: current
            }
          };
          EventBus.$emit("route", payload);
        }
      },
      {
        icon: "fal fa-trash-alt",
        class: "table__actions",
        id: "btn_delete_user",
        visibleCondition: () =>
          store.getters["authModule/hasPermission"](policyList.deleteUsers),
        modalActions: {
          modalNumber: 1,
          modalQuestion: "Are you sure you want to delete this customer?",
          modalSuccessText: "yes",
          modalIdSuccess: "btn_delete_yes",
          modalSuccessAction: (
            // This is a workaround for type until next lib release.
            response: TableSuccessModalResponse & { item: any }
          ) => {
            store
              .dispatch("UserModule/deleteUser", response.item)
              .then(() => response.unselectModal())
              .finally(() => execute());
          },
          modalCancelText: "No",
          modalIdCancel: "btn_delete_no",
          modalButtonsClass: "buttonClass_5"
        },
        otherComponent: {
          name: "TableModalComponent"
        }
      }
    ];
  }
}

export const USER_SERVICE = new UserService();
